import { fromJS, Record } from 'immutable';
import { snakeCase } from 'lodash';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { CurrentPlanBilling } from './current-plan-billing.model';

export enum PlanWindowsEnum {
  trial = 'trial',
  upsell = 'upsell',
  expired = 'expired',
  expiring = 'expiring',
}

export enum PlanDurationUnitEnum {
  day = 'day',
  month = 'month',
  year = 'year',
}

export enum SubscriptionTypeEnum {
  invoice2go_managed = 'invoice2go_managed',
  recurring_braintree = 'recurring_braintree',
  recurring_apple = 'recurring_apple',
  recurring_google = 'recurring_google',
}

export enum ProductPlanTypeEnum {
  trial = 'trial',
  paygo = 'paygo',
  starter = 'starter',
  pro = 'pro',
  enterprise = 'enterprise',
  unlimited = 'unlimited',
  cloud = 'cloud',
  demo = 'demo',
  freemium = 'freemium',
}

export const CURRENT_PLAN_SCHEMA = Object.freeze({
  PLAN_NAME: '',
  PLAN_DURATION_UNIT: PlanDurationUnitEnum,
  EXPIRY_DATE_UTC: '', // i2g-date-time (yyyy-mm-dd'T'hh:mm:ssZ)
  WINDOW: '',
  PROPENSITY: '',
  AUTORENEW_ENABLED: false,
  PLAN_UUID: '',
  PLAN_TYPE: ProductPlanTypeEnum,
  SUBSCRIPTION_TYPE: SubscriptionTypeEnum,
  BILLING: CurrentPlanBilling,
});
const RECORD = generateSchema(CURRENT_PLAN_SCHEMA);
const KEYS: any = generateKeys(CURRENT_PLAN_SCHEMA);

export class CurrentPlan extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});
    super(props);

    return setInModel(this, [
      {
        key: KEYS.BILLING,
        value: props.get(KEYS.BILLING)
          ? new CurrentPlanBilling(this.billing)
          : null,
      },
    ]) as CurrentPlan;
  }

  get planName(): string {
    return this.get(KEYS.PLAN_NAME);
  }

  get planDurationUnit(): PlanDurationUnitEnum {
    return this.get(KEYS.PLAN_DURATION_UNIT);
  }

  get expiryDateUtc(): string {
    return this.get(KEYS.EXPIRY_DATE_UTC);
  }

  get window(): string {
    return this.get(KEYS.WINDOW);
  }

  get autoRenewEnabled(): boolean {
    return this.get(KEYS.AUTORENEW_ENABLED);
  }

  get planUuid(): string {
    return this.get(KEYS.PLAN_UUID);
  }

  get planType(): ProductPlanTypeEnum {
    return this.get(KEYS.PLAN_TYPE);
  }

  get billing(): CurrentPlanBilling {
    return this.get(KEYS.BILLING);
  }

  get subscriptionType(): SubscriptionTypeEnum {
    return this.get(KEYS.SUBSCRIPTION_TYPE);
  }

  isTrialWindow(): boolean {
    return snakeCase(this.window).toLowerCase() === PlanWindowsEnum.trial;
  }

  isFreemiumPlan(): boolean {
    return this.planType.toLowerCase() === ProductPlanTypeEnum.freemium;
  }

  isRenewalWindow(): boolean {
    return (
      ([PlanWindowsEnum.expiring, PlanWindowsEnum.expired] as any[]).indexOf(
        snakeCase(this.window).toLowerCase()
      ) > -1
    );
  }
}
